import { useState, useEffect } from "react";
import { API_URL } from "../config/endpoints";

export const useGetBookingEngine = () => {
  const apiUrl = `${API_URL}/guest/booking-engine/website`;
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [bookingEngineData, setBookingEngineData] = useState<any>(null);

  useEffect(() => {
    const fetchBookingEngineData = async () => {
      setLoading(true);
      setErrorMessage(null);

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(
            "Failed to fetch booking engine data. Please try again."
          );
        }

        const data = await response.json();
        setBookingEngineData(data);
      } catch (error) {
        if (error instanceof Error) {
          setErrorMessage(error.message);
        } else {
          setErrorMessage("An unexpected error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchBookingEngineData();
  }, [apiUrl]); // Only re-run if apiUrl changes

  return {
    loading,
    errorMessage,
    bookingEngineData,
  };
};
